import I18n from 'I18n';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { useLowercaseCrmObjectTypeName } from 'framework-listing-lib/internal/hooks/useCrmObjectTypeName';
import { jsx as _jsx } from "react/jsx-runtime";
export default function NavItemTooltip({
  disabled,
  selectedAssetCount,
  children
}) {
  const {
    lowerCaseObjectTypeNamePlural,
    lowerCaseObjectTypeNameSingular,
    capitalizedObjectTypeNamePlural,
    capitalizedObjectTypeNameSingular
  } = useLowercaseCrmObjectTypeName();
  return /*#__PURE__*/_jsx(Tooltip, {
    "data-test-id": 'nav-item-tooltip',
    title: I18n.text('frameworkListingLib.folders.moveAssetsModal.footer.moveTooltip', {
      count: selectedAssetCount || 0,
      objectTypeName: lowerCaseObjectTypeNameSingular,
      objectTypeNamePlural: lowerCaseObjectTypeNamePlural,
      capitalizedObjectTypeNameSingular,
      capitalizedObjectTypeNamePlural
    }),
    disabled: disabled,
    children: children
  });
}